/**
 * 英文
 */
const lang = {
  login: {
    usernamePlaceholder: 'Please select username',
    passwordPlaceholder: 'Please enter your password',
    rememberPassword: 'Remember password',
    login: 'LogIn',
    incorrectPasswordTip: 'The password is incorrect, please re-enter!'
  },
  caseManagement: 'Management',
  caseUpload: 'Upload',
  scanSettings: 'Settings',
  scanSettingsStart: 'Start',
  scanSettingsSuspend: 'Suspend',
  scanSettingsStop: 'Stop',
  scanSettingsReset: 'Reset',
  language: 'Lang',
  welcome: 'Welcome',
  exit: 'Logout',
  exitContent1: 'After you log out, you will be redirected to the login page',
  exitContent2: 'Are you sure to exit',
  newCase: 'New Case',
  pathologyNumber: 'Case No.',
  caseStatus: 'Case Status',
  entryTime: 'Entry Time',
  startingTime: 'Starting time',
  endTime: 'End Time',
  entryTimeTip: 'Entry start time cannot be greater than end time',
  inquire: 'Search',
  refresh: 'Refresh',
  tableName: 'Case List',
  /* Case list */
  caseList: {
    serialNumber: 'No.',
    name: 'Name',
    gender: 'Gender',
    menAndWomen: {
      male: 'Male',
      female: 'Female'
    },
    age: 'Age',
    uploadStatus: 'Status',
    fast: 'Fast',
    // 是否快速
    isFast: {
      yes: 'Yes',
      no: 'No'
    },
    caseType: 'Case type',
    sentToHospital: 'Center',
    number: 'Case No.',
    sample: 'Specimen',
    createDt: 'CreateDt',
    operating: 'Action',
    // 删除按钮提示
    deletePrompt: {
      title: 'Delete case',
      content: 'Confirm to delete this case, it cannot be restored after deletion'
    },
    // 删除结果提示
    deleteResultPrompt: {
      title: 'Prompt',
      success: 'successfully deleted',
      failed: 'failed to delete'
    },
    // 消息提醒
    messageNotification: 'message notification',
    // 编辑诊断结果提示
    editDiagnosisResultPrompt: 'The case has not been scanned, please edit after the analysis is complete!',
    // 筛选数据提示
    filterDataTips: 'The case has not been scanned, please screen after the analysis is complete!',
    // 诊断子按钮
    dataFilteringButton: 'Filtering',
    diagnosticResultButton: 'Result',
    viewReportButton: 'Report',
    editDiagnosisResults: 'Edit diagnosis results'
  },
  slideTable: {
    serialNumber: 'No.',
    sample: 'Specimen',
    slide: 'Slide',
    sampleType: 'Spec-Type',
    analysisType: 'AnalysisType',
    analysisResult: 'Analysis Outcome',
    feminine: 'Feminine',
    positive: 'Positive',
    numberOfCells: 'Cell Amount',
    status: 'Status',
    operation: 'Action',
    noSlides: 'NoSlides',
    printBarcode: 'Print QR',
    delete: 'Delete',
    deleteTipTitle: 'RemoveSlide',
    deleteTip: 'Are you sure to delete this slide, it cannot be restored after deletion!',
    successfullyDeletedTip: 'successfully deleted',
    failedToDeleteTip: 'failed to delete',
    deletedTip: 'Prompt'
  },
  // Operation button
  deleteButton: 'Del',
  editButton: 'Edit',
  diagnosisButton: 'Diagnose',
  barcodePrintingButton: 'Print QR',
  // 扫描数量统计
  scanNum: {
    tongji: 'statistical',
    zbls: 'The total number of cases',
    zbps: 'The total number of slides',
    zupload: 'All uploaded several',
    yesterday: 'Yesterday',
    ydayCaseNum: 'The number of cases',
    ydaySlideNum: 'Number of slides',
    ydayLayerUpNum: 'Has been scan/upload',
    today: 'Today',
    tdayCaseNum: 'The number of cases',
    tdaySlideNum: 'Number of slides',
    tdayLayerUpNum: 'Has been scan/upload',
    leaf: ' ',
    case: ' ',
    dingScanNum: 'scan'
  },
  // 新建病例
  addNewCase: {
    patientInfo: {
      QRCodeInformation: 'QR code：',
      QRPlaceholder: ' Please Scan the QR code',
      name: 'Name：',
      namePlaceholder: ' Patient’s name enters here',
      gender: 'Gender：',
      genderTip: 'Please select patient gender!',
      menAndWomen: {
        male: 'Male',
        female: 'Female'
      },
      age: 'Age：',
      agePlaceholder: 'Please enter age',
      consultationNumber: 'Visit No.：',
      consultationNumberPlaceholder: 'Enter the No. for clinical visit',
      typeOfCertificate: 'ID Type：',
      IDNumber: 'ID No.：',
      IDNumberPlaceholder: 'Enter the patent’s ID No.',
      medicalInsuranceCardNumber: 'Medicare No.：',
      medicalInsuranceCardNumberPlaceholder: ' No. on the medicare card',
      dateOfBirth: 'Date of Birth：',
      dateOfBirthPlaceholder: 'Choose the date',
      contactNumber: 'Contact No.：',
      contactNumberPlaceholder: 'The phone No. of patient',
      address: 'Contact Address：',
      addressPlaceholder: ' The address of patient',
      internetCaseSearch: 'InternetCaseSearch：',
      checklistNumberPlaceholder: 'Please enter the checklist number',
      correctContactNumber: 'Please enter the correct contact number',
      cancel: 'cancel',
      inquire: 'Search'
    },
    caseInfo: {
      pathologyNumber: 'Case No.：',
      pathologyNumberPlaceholder: 'Case No. enters here',
      rapidCase: 'Fast Case：',
      caseType: 'Case Type：',
      inspectionDepartment: 'Specimen Department：',
      inspectionDate: 'Receiving Date：',
      inspectionDatePlaceholder: 'inspection date',
      sendingDoctor: 'Primary physician：',
      sendingDoctorPlaceholder: 'Enter the full name here',
      sendingDoctorTip: 'Please limit your keywords to 15 characters！',
      sentToHospital: 'Medicare Center：',
      sampleType: 'Specimen Type：',
      sampleTypeMessage: 'Specimen Type!',
      sampleTypeTip: 'Please limit your keywords to 15 characters!',
      sampleTypePlaceholder: 'Specimen Type',
      analysisType: 'Analysis Type：',
      analysisTypeMessage: 'Please enter the analysis type!',
      numberOfSlides: 'Number of Slides:',
      operationButton: 'Edit',
      selectPictureButton: 'picture',
      deleteButton: 'delete',
      addSampleButton: 'Add Specimen',
      hospitalNumber: 'Admission No.：',
      hospitalNumberPlaceholder: 'Please enter the hospital admission No.',
      ward: 'Ward Area：',
      wardPlaceholder: 'Please enter the ward area',
      bedNumber: 'Bed No.：',
      bedNumberPlaceholder: 'Please enter the patient’s bed No.',
      phoneNumberOfSendingPhysician: 'Physician Contact No.：',
      phoneNumberOfSendingPhysicianPlaceholder: 'Please enter the physician’s phone No.',
      menstruateLastTime: 'Last menstrual period starts：',
      menstruateLastTimePlaceholder: 'Choose the date',
      deadline: 'Last menstrual period ends：',
      deadlinePlaceholder: 'Choose the date',
      medicalHistory: 'Medical Records：',
      medicalHistoryPlaceholder: ' Please enter the patient’s medical records',
      clinicalDiagnosis: 'Clinical Diagnosis：',
      clinicalDiagnosisPlaceholder: 'Please enter the clinical diagnosis',
      visibleToTheNakedEye: 'Visible to the Unaided Eye：',
      visibleToTheNakedEyePlaceholder: 'Please enter the naked eye diagnosis  ',
      cancel: 'Cancel',
      confirm: 'OK',
      phoneNumberTip: 'Please enter the correct contact number!',
      pathologyNumberTip: 'Please enter Case No.!',
      CaseTypeTip: 'Please enter the case type!',
      inspectionDepartmentTip: 'Please enter the inspection department!',
      sentToHospitalTip: 'Please enter the hospital for inspection!',
      sendingDoctorMessage: 'Please enter the Primary physician!',
      imageManagement: 'Image management',
      fastTip: 'Please choose whether to fast！',
      // 是否快速
      isFast: {
        yes: 'YES',
        no: 'NO'
      }
    },
    netPatientNoPaymentTip: 'The inspection order has not been paid, please contact the administrator if you have any questions',
    netPatientNetworkErrorip: 'Network error, please try again or contact the administrator',
    orderNotExistTip: 'The inspection order does not exist, please contact the administrator if you have any questions',
    addCaseTip: 'Please enter the information correctly as required!',
    moreInformation: 'More',
    collapseInformation: 'Pack Up',
    consummation: 'Finish',
    barcodePrinting: 'Print QR Code'
  },
  editCase: {
    patientInformation: 'Patient information',
    sampleSlide: 'Sample slide',
    sampleDetails: 'Sample details',
    slideDetails: 'Slide details',
    sampleNumber: 'SampleNumber：',
    sampleDescription: 'SampleDescription：',
    saveSuccess: 'The patient case information is saved successfully!',
    saveFailure: 'Failed to save human case information!',
    save: 'SAVE',
    saveSample: 'Save sample',
    captureImage: 'Capture image',
    slideNumber: 'SlideNum：',
    saveTheSlide: 'Save Slide',
    slideNumberTip: 'Please enter the slide number!',
    addSampleSuccessfully: 'Add sample successfully!',
    failedToAddSample: 'Failed to add sample!',
    sampleNumberTip: 'Please enter the sample number!',
    // 保存样本成功
    saveTheSampleSuccessfully: 'Save the modified sample successfully!',
    // 保存样本失败
    failedToSaveSample: 'Failed to save modified sample!',
    addSample: 'Add sample',
    addSlide: 'Add slide',
    removeSlide: 'Remove slide',
    removeSlideTip: 'Are you sure to delete this slide, it cannot be restored after deletion!',
    removeSlideSuccessfully: 'Successfully delete slides!',
    removeSlideFailed: 'Failed to delete slides!',
    saveSlideSuccessfully: 'Save the modified slide successfully!',
    saveSlideFailed: 'Failed to save modified slide!',
    successfullyAddedSlideTip: 'Successfully added slides!',
    failedToAddSlideTip: 'Failed to add slide!'
  },
  captureImage: {
    successTip: 'The drawing image is added successfully!',
    addTip: 'Please add a source image!',
    existingTip: 'Successful acquisition of the existing material image!',
    sizeOfPictureTip: 'Picture size cannot exceed 6 M!',
    deletedTip: 'The captured image has been deleted from the database!'
  },
  diagnosis: {
    errorReminder: 'Error reminder',
    reportDoesNotExistTip: 'The current case report does not exist, please edit the report first!',
    failedToEditReportTip: 'Failed to edit the report, please check whether the DNA.txt file exists!',
    closeReport: 'Close report',
    diagnosticResult: 'DiagnosticResult：',
    diagnosticResultPlaceholder: 'Please enter DNA comments...',
    comprehensiveAdvice: 'Recommend：',
    comprehensiveAdvicePlaceholder: 'Please enter suggestions...',
    reportDate: 'ReportDate：',
    reportDatePlaceholder: 'Please select report date...',
    reportImage: 'ReportImage：',
    reportImagePlaceholder: 'Please select a picture',
    cancel: 'cancel',
    saveReport: 'OK',
    editReport: 'OK',
    addReportResultsSuccess: 'The report result is added successfully!'
  },
  message: 'Hello',
  caseImport: {
    title: 'CaseImport',
    precautionsTitle: 'Precautions',
    precautionsContent1: '1. The file format only supports xls, xlsx.',
    precautionsContent2: '2. If there is an error message, please modify the error data according to the prompts.',
    precautionsContent3: '3. Make the modified data into a new excel and re-import it until all succeeds!',
    downloadXlsx: 'Download',
    uploadTip: 'Click or drag files here to upload',
    fileName: 'File to be uploaded：',
    export: 'Export',
    updateDateText: 'Update time：',
    uploading: 'uploading...',
    startUpload: 'StartUpload',
    printing: 'Printing...',
    startPrinting: 'StartPrinting',
    analysisTypeTip: 'Please select the analysis type!',
    numberOfLines: 'numberOfLines',
    errorMessage: 'ErrorMessage',
    fileFormatTipTitle: 'Incorrect file format',
    fileFormatTipContent1: 'file',
    fileFormatTipContent2: 'The format is incorrect, please upload .xls, .xlsx files.',
    fileFormatUploadTip: 'File type error',
    fileFormatUploadTipDesc1: 'file',
    fileFormatUploadTipDesc2: 'It is not an EXCEL file, please select an EXCEL file with the suffix .xlsx or .xls.',
    printTipConfirmTitle: 'warning',
    printTipConfirmContent: 'The QR code of the currently imported case will be printed!',
    printTipConfirmOkText: 'Understand, confirm print',
    printTipConfirmCancelText: 'NoThankYou',
    printTipSucessTitle: 'Prompt for success',
    printTipSucessDesc: 'The QR code is printed successfully!',
    printTipWarningTitle: 'Tip',
    printTipWarningDesc: 'Please do not submit repeatedly!',
    uploadFunSucessTitle: 'promptForSuccess',
    uploadFunSucessDesc: 'The case is imported successfully. If there is an error message, the data list can be exported!',
    uploadFunWarningTitle: 'Tip',
    uploadFunWarningDesc: 'Please do not submit repeatedly!',
    handleSuccessTip: 'Data imported successfully！',
    uploadErrorTip: 'Data import failed!',
    exportDataTip: 'No relevant data, please try again later!',
    cancelPrinting: 'Cancel printing',
    uploadFunErrorTitle: 'Tip',
    uploadFunErrorDesc: 'An exception occurred on the server side!'
  },
  scanAddNewCase: {
    title: 'Scan',
    code: 'scanCodeInformation：',
    pathologyId: 'caseNumber：',
    slideCount: 'numberOfProductions：',
    sourceName: 'sourceOfInspection：',
    codePlaceholder: 'Please scan the QR code information...',
    pathologyIdPlaceholder: 'Please enter the case number...',
    slideCountPlaceholder: 'Please enter the number of productions...',
    sourceNamePlaceholder: 'Please enter the source of submission for inspection...'
  }
}

export default lang



// WEBPACK FOOTER //
// ./src/utils/lang/en-us.js